// expandable-cell.component.ts
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TruncateSpanComponent } from '../util/span-truncate/truncate-span.component';
import { MAX_NAME_DISPLAY_SIZE } from '../../app.constants';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'jhi-expandable-cell',
    template: `
        @if (data && data.length > 0) {
            <div class="custom-scroll-style expandable-cell-content">
                @for (value of data; track $index) {
                    @if ($index < numberOfItemsToShow) {
                        @if (asLink && value !== 'UNKNOWN') {
                            <a class="link ms-2 mt-2"
                               (click)="onItemClick($index)"><truncate-span [textInput]="value" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></a>
                        } @else {
                            <span class="ms-2 mt-2"><truncate-span [textInput]="value" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></span>
                        }
                        @if ($index < data.length - 1) {
                            <span>,</span>
                        }
                    }
                }
                @if (!expanded) {
                    @if (data.length > numberOfItemsToShow) {
                        <button (click)="toggleExpand()" class="btn btn-sm btn-link small fst-italic"><span class="text-muted text-black fw-bold">...{{ data.length - initialItemsToShow }}</span> {{ 'common.more.items' | translate}}</button>
                    }
                } @else {
                    <button class="btn btn-sm btn-link fst-italic" (click)="toggleExpand()">
                        {{ 'common.show.less' | translate }}
                    </button>
                }
            </div>
        }
    `,
    standalone: true,
    imports: [
        TruncateSpanComponent,
        TranslateModule
    ],
    styles: [`
        .btn-link {
            padding: 0;
            margin-left: 8px;
            vertical-align: baseline;
        }

        .expandable-cell-content {
            transition: max-height 0.3s ease-out;
            max-height: 400px;
            max-width: 350px;
            y-overflow: auto;
            overflow-y: auto;
            overflow-x: hidden;
            x-overflow: hidden;
            text-wrap: wrap;
            word-wrap: break-word;
            overflow-wrap: break-word;
            word-break: break-all;
            padding: 5px;
        }

    `]
})
export class ExpandableCellComponent implements OnInit {

    MAX_NAME_DISPLAY_SIZE = MAX_NAME_DISPLAY_SIZE;

    @Input() data: any[] | any = [];
    @Input() initialItemsToShow: number = 5;
    @Input() asLink: boolean = true;
    @Output() itemClick = new EventEmitter<number>();

    expanded: boolean = false;
    displayedData: string = '';
    fullData: string = '';
    numberOfItemsToShow: number = this.initialItemsToShow;

    ngOnInit() {
    }

    toggleExpand() {
        this.expanded = !this.expanded;
        if (this.expanded) {
            this.numberOfItemsToShow = this.data.length;
        } else {
            this.numberOfItemsToShow = this.initialItemsToShow;
        }
    }

    onItemClick(itemIndex: number) {
        this.itemClick.emit(itemIndex);
    };
}
